module.exports = __webpack_public_path__ + "img/expoglitter_1910_black_with_gold_glitters.09eca29a.jpg";